import { createStore } from 'vuex'
import ui from './modules/ui'
export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    ui
  }
})